import React from 'react';
import { connect } from 'react-redux';

import Repeater from '@Utils/Repeater';
import { AppState } from '@Redux/store';
import { Nullable } from '@Models';
import { ShowItem } from '@Selectors/builder/myArmyList/make/unit/show/show';
import { ModelRuleView } from '@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface IUnitOptionProfilProps {
  modelRules: Array<ModelRuleView>;
  magic: Nullable<string>;
  notes: Nullable<string>;
}

const UnitOptionProfil: React.FC<UnitOptionProfilProps> = ({
                                                             modelRules,
                                                             magic,
                                                             notes
                                                           }) => {

  return (
    <>
      {modelRules.length > 0 && <div className="col-12 col-md-4 option">
        <h4><FormattedMessage {...defaultMessages.armyListUnitShowModelRules} /></h4>
        <ul>
          <Repeater data={modelRules} indexPrefix='model_rule'>
            {
              (item: ShowItem) => <li><a href={item.url!} target={'_blank'}>{item.name}</a></li>
            }
          </Repeater>
        </ul>
      </div>}

      {magic != null && <div className="col-12 option">
        <h4><FormattedMessage {...defaultMessages.armyListUnitShowMagic} /></h4>
        {magic}
      </div>}

      {notes != null && <div className="col-12 option">
        <h4><FormattedMessage {...defaultMessages.armyListUnitShowNotes} /></h4>
        {notes}
      </div>}
    </>
  );
};

const mapStateToProps = (_: AppState, owsProps: IUnitOptionProfilProps) => ({
  modelRules: owsProps.modelRules,
  magic: owsProps.magic,
  notes: owsProps.notes
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UnitOptionProfil);

type UnitOptionProfilProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
